import _ from 'lodash';
import isPrimitive from './isPrimitive';
import Enveloped from './Interfaces';

function wrap(object: readonly object[]): Enveloped;
function wrap(object: object): object;
function wrap(object: object): object {
  if (_.isArray(object)) {
    return {
      data: object.map((value) => {
        if (value && typeof value === 'object' && !isPrimitive(value)) {
          return wrap(value);
        }
        return value;
      }),
    };
  }
  return _.mapValues(object, (value) => {
    if (value && typeof value === 'object' && !isPrimitive(value)) {
      return wrap(value);
    }
    return value;
  });
}

export default wrap;
